const numericCompareOperators = {
  equals: "Equals",
  greaterThan: "Greater Than",
  greaterThanOrEquals: "Greater Than Or Equals",
  lessThan: "Less Than",
  lessThanOrEquals: "Less Than Or Equals"
}
export default numericCompareOperators
